import React from 'react';

import Newsletter from '@/components/newsletter';
import { WavingHand } from '@/components/waving-hand';
import { ProjectItem } from '@/components/project-item';
import { Container } from '@/components/container';
import { Text as DesignText } from '@/components/ui/text';
import { Box } from '@/components/ui/box';

const App = React.memo(() => {
  return (
    <Container>
      <Box className="space-y-6 max-w-2xl mt-8 md:mt-24 flex-col flex mb-3">
        <Box className="flex flex-row">
          <Box className="text-3xl font-semibold">
            <WavingHand />
          </Box>
        </Box>
        <DesignText variant="body">
          I'm Enzo, though you might know me better as Reactiive.
        </DesignText>
        <DesignText variant="body">
          I have a passion for creating animations and enjoy sharing my insights
          along the way. That's what this blog is all about.
        </DesignText>
      </Box>
      <Newsletter withBottomMargin={false} />

      <Box className="mt-14">
        <DesignText
          variant="caption"
          className="uppercase tracking-widest text-text-tertiary mb-4"
        >
          Projects
        </DesignText>
        <ProjectItem
          title="Reanimate.dev"
          href="https://reanimate.dev"
          tag="Course"
          description="Designed to guide you from the basics to advanced techniques."
        />
        <ProjectItem
          title="Demos"
          href="/demos"
          newPage={false}
          tag="Open Source"
          description="100+ React Native experiments and demos."
        />
        <ProjectItem
          title="YouTube"
          href="https://youtube.com/@Reactiive"
          tag="Tutorials"
          description="React Native tutorials and animation breakdowns."
        />
      </Box>
    </Container>
  );
});

export default App;
